const title = (
  t: any,
  text: string = t("report.Number of Locations")
)=> ({
  text,
  top: "bottom",
  left: "center",
  textStyle: {
    color: "#333",
    fontSize: 10,
    fontWeight: 500
  }
});

export default title;
